var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgIcChangePassword = ({
  title,
  titleId,
  ...props
}, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 34,
  height: 34,
  viewBox: "0 0 34 34",
  ref: ref,
  "aria-labelledby": titleId
}, props), title ? /*#__PURE__*/React.createElement("title", {
  id: titleId
}, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#3f68b5;}.b,.c,.d{fill:none;}.c,.d{stroke:#fff;}.c{stroke-width:1.5px;}.e{stroke:none;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
  transform: "translate(-1652 -93)"
}, /*#__PURE__*/React.createElement("circle", {
  className: "a",
  cx: 17,
  cy: 17,
  r: 17,
  transform: "translate(1652 93)"
}), /*#__PURE__*/React.createElement("g", {
  transform: "translate(1162 -19.745)"
}, /*#__PURE__*/React.createElement("rect", {
  className: "b",
  width: 24,
  height: 24,
  transform: "translate(495 117.745)"
}), /*#__PURE__*/React.createElement("g", {
  transform: "translate(499.889 119.745)"
}, /*#__PURE__*/React.createElement("g", {
  className: "c",
  transform: "translate(-0.389 5.952)"
}, /*#__PURE__*/React.createElement("rect", {
  className: "e",
  width: 15,
  height: 13,
  rx: 2
}), /*#__PURE__*/React.createElement("rect", {
  className: "b",
  x: 0.75,
  y: 0.75,
  width: 13.5,
  height: 11.5,
  rx: 1.25
})), /*#__PURE__*/React.createElement("g", {
  className: "c",
  transform: "translate(3.111)"
}, /*#__PURE__*/React.createElement("path", {
  className: "e",
  d: "M4,0H4A4,4,0,0,1,8,4V7.333a0,0,0,0,1,0,0H0a0,0,0,0,1,0,0V4A4,4,0,0,1,4,0Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "b",
  d: "M4,.75H4A3.25,3.25,0,0,1,7.25,4V6.366a.217.217,0,0,1-.217.217H.967A.217.217,0,0,1,.75,6.366V4A3.25,3.25,0,0,1,4,.75Z"
})), /*#__PURE__*/React.createElement("g", {
  className: "d",
  transform: "translate(5.111 11.698)"
}, /*#__PURE__*/React.createElement("circle", {
  className: "e",
  cx: 2,
  cy: 2,
  r: 2
}), /*#__PURE__*/React.createElement("circle", {
  className: "b",
  cx: 2,
  cy: 2,
  r: 1.5
})))))));
const ForwardRef = /*#__PURE__*/forwardRef(SvgIcChangePassword);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "matrices-static/media/ic_change_password.0fff689228ed6b1ed10ea4fe69886099.svg";